import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const TextInputRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const isTextarea = question.type === 'textarea';
  const isEmail = question.type === 'email';

  const baseClasses = `w-full px-4 py-3 border rounded-lg transition-colors ${
    error
      ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
      : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500'
  } focus:outline-none focus:ring-2`;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  if (isTextarea) {
    return (
      <textarea
        value={value || ''}
        onChange={handleChange}
        placeholder={question.placeholder}
        className={`${baseClasses} min-h-32 resize-y`}
        maxLength={question.settings?.maxLength}
        aria-invalid={!!error}
        aria-describedby={error ? `${question.id}-error` : undefined}
      />
    );
  }

  return (
    <input
      type={isEmail ? 'email' : 'text'}
      value={value || ''}
      onChange={handleChange}
      placeholder={question.placeholder}
      className={baseClasses}
      maxLength={question.settings?.maxLength}
      aria-invalid={!!error}
      aria-describedby={error ? `${question.id}-error` : undefined}
    />
  );
};

export default TextInputRenderer;
